// extracted by mini-css-extract-plugin
export default {"container":"RegistrationClosed_container--T_n","image":"RegistrationClosed_image--r2f","text":"RegistrationClosed_text--cvJ"};